import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Collapse from "react-bootstrap/lib/Collapse";

import { translate as t } from '../../../lib/I18n';
import config from '../../../config';
import { RefundCalculation } from '../../../constants/AppConstants';

import TicketRefundCalculation from "../../../records/refund/TicketRefundCalculation";
import Order from '../../../records/Order';
import OrderTicket from '../../../records/order/Ticket';

import Price from '../../general/Price';
import Icon from '../../general/Icon';
import FeatureFlag from '../../general/FeatureFlag';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import TicketCalculationsSummaryHeader from "./TicketCalculationsSummaryHeader";

class TicketCalculationsSummary extends React.PureComponent {
    static propTypes = {
        storedRefundCalculation: PropTypes.instanceOf(TicketRefundCalculation),
        ticket: PropTypes.instanceOf(OrderTicket),
        refundDetails: PropTypes.instanceOf(Order),
        shouldUseCalculations: PropTypes.bool,
        isSmartcard: PropTypes.bool,
    };

    state = {
        showRefundDetail: false,
    };

    showMoreDetails = () => {
        this.setState({
            showRefundDetail: !this.state.showRefundDetail,
        });
    };

    render () {
        const { showRefundDetail } = this.state;
        const { storedRefundCalculation, ticket, refundDetails, shouldUseCalculations } = this.props;

        const calc = storedRefundCalculation && storedRefundCalculation.get('calculation');
        const initiatedBy = storedRefundCalculation && storedRefundCalculation.get('initiatedBy');

        if (!refundDetails || !ticket.isRefunded) {
            return null;
        }

        if (!calc || (initiatedBy === RefundCalculation.initiatedByCustomer)) {
            return (
                <div className="refund-ticket">
                    <TicketCalculationsSummaryHeader
                        showRefundDetail={showRefundDetail}
                        storedRefundCalculation={storedRefundCalculation}
                        ticket={ticket}
                        onClick={this.showMoreDetails}
                    />
                    <Collapse in={ showRefundDetail }>
                        <div className="refund-ticket__body">
                            <Row>
                                <Col xs={ 8 }>{t('account.orders.refund.initiatedBy')}</Col>
                                <Col xs={ 4 } className="text-right">{t('account.orders.refund.customer')}</Col>
                            </Row>
                            <Row>
                                <Col xs={ 8 }>{t('order.summary.total_paid')}</Col>
                                <Col xs={ 4 } className="text-right"><Price price={ ticket.price }/></Col>
                            </Row>

                            <Row className="text-weight--normal">
                                <Col xs={8}>
                                {t('account.orders.refund.itso.valueUsed')}
                                    <span className="sr-only">. </span>
                                </Col>
                                <Col xs={4} className="text-right price">
                                    <Price price={calc && calc.totalUsed} />
                                    <span className="sr-only">. </span>
                                </Col>
                            </Row>

                            <Row className="text-weight--normal">
                                <Col xs={8}>
                                    {t('account.orders.refund.ticketValue')}
                                    <span className="sr-only">. </span>
                                </Col>
                                <Col xs={4} className="text-right price">
                                    <Price price={calc && calc.refundAmount} />
                                    <span className="sr-only">. </span>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={ 12 }><hr className="refund-ticket__body__divisor" /></Col>
                            </Row>
                            <Row className="text-weight--bold">
                                <Col xs={ 8 }>{t('account.orders.refund.summary.totalRefunded')}</Col>
                                <Col xs={ 4 } className="text-right"><Price price={ calc && calc.refundAmount }/></Col>
                            </Row>
                        </div>
                    </Collapse>
                </div>
            );
        }

        return (
            <div className="refund-ticket">
                <TicketCalculationsSummaryHeader
                    showRefundDetail={showRefundDetail}
                    storedRefundCalculation={storedRefundCalculation}
                    ticket={ticket}
                    onClick={this.showMoreDetails}
                />
                <Collapse in={ showRefundDetail }>
                    <div className="refund-ticket__body">
                        <Row>
                            <Col xs={ 8 }>{t('account.orders.refund.initiatedBy')}</Col>
                            <Col xs={ 4 } className="text-right">{t('account.orders.refund.customerService')}</Col>
                        </Row>
                        <Row>
                            <Col xs={ 8 }>{t('order.summary.total_paid')}</Col>
                            <Col xs={ 4 } className="text-right"><Price price={ calc.originalAmount }/></Col>
                        </Row>
                        {shouldUseCalculations && (
                            <Row>
                                <Col xs={ 7 }>{t('account.orders.refund.itso.valueUsed')}
                                    <FeatureFlag name="enableSeasonRefundsMoreInfo">
                                        <a target="_blank" href={ config.get('smartcardRefundInformationUrl') }>
                                            <Icon icon="info" className="margin-left--xs otrl-sm" />
                                        </a>
                                    </FeatureFlag>
                                </Col>
                                <Col xs={ 5 } className="text-right">
                                    {calc.totalUsed > 0 &&
                                    <FormattedHTMLMessage
                                        message='account.orders.refund.itso.deduction.amount'
                                        amount={ <Price price={ calc.totalUsed }/> }
                                    />}
                                    {calc.totalUsed === 0 &&
                                    <Price price={ calc.totalUsed }/>}
                                </Col>
                            </Row>
                        )}
                        {!shouldUseCalculations && (
                            <Row>
                                <Col xs={ 7 }>
                                    {t('account.orders.refund.dayticket.valueRefunded')}
                                </Col>
                                <Col xs={ 5 } className="text-right">
                                    <Price price={ calc.refundAmount }/>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col xs={ 12 }><hr className="refund-ticket__body__divisor" /></Col>
                        </Row>
                        <Row className="text-weight--bold">
                            <Col xs={ 8 } >{t('account.orders.refund.summary.totalRefunded')}</Col>
                            <Col xs={ 4 } className="text-right">
                                <Price price={ calc.refundAmount } />
                            </Col>
                        </Row>
                    </div>
                </Collapse>
            </div>
        );
    }
}

export default TicketCalculationsSummary;
